<mat-card class="widget-card">
    <mat-card-header>
      <mat-card-title>Expenses by Category</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="chartContainer">
            <canvas baseChart class="chart" [data]="chartData" [options]="chartOptions" [plugins]="chartPlugins" type="pie"></canvas>
        </div>
    </mat-card-content>
  </mat-card>